import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
interface LoginPageProps {
  onNavigate: (page: string) => void;
}
export function LoginPage({
  onNavigate
}: LoginPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('alexrossi@example.com');
  const [password, setPassword] = useState('password123');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      onNavigate('home');
    }, 1000);
  };
  return <div className="min-h-screen bg-green-600 flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-980">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/wsCbUWp4TF3ni7DwEfb9qP/hand-drawn-turtle-shell-pattern_23-2150598661.jpg)'
    }} data-id="element-981" />

      <div className="w-full max-w-md relative z-10" data-id="element-982">
        {/* Logo and Title */}
        <div className="text-center mb-6" data-id="element-983">
          <div className="inline-block bg-white rounded-2xl p-3 mb-3 shadow-lg" data-id="element-984">
            <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback Logo" className="h-10 w-auto" data-id="element-985" />
          </div>
          <h1 className="text-xl font-normal text-white" data-id="element-986">Accedi a Greenback</h1>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100" data-id="element-987">
          <form onSubmit={handleLogin} className="space-y-4" data-id="element-988">
            {/* Email Input */}
            <div className="space-y-1.5" data-id="element-989">
              <label className="text-sm font-normal text-gray-700 block" data-id="element-990">
                Email
              </label>
              <div className="relative" data-id="element-991">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full px-4 py-2.5 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:border-green-500 focus:ring-1 focus:ring-green-500 transition-colors text-sm" placeholder="alexrossi@example.com" required data-id="element-992" />
              </div>
            </div>

            {/* Password Input */}
            <div className="space-y-1.5" data-id="element-993">
              <label className="text-sm font-normal text-gray-700 block" data-id="element-994">
                Password
              </label>
              <div className="relative" data-id="element-995">
                <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="block w-full px-4 py-2.5 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:border-green-500 focus:ring-1 focus:ring-green-500 transition-colors text-sm" placeholder="••••••••" required data-id="element-996" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-997">
                  {showPassword ? <EyeOff className="h-4 w-4 text-gray-400 hover:text-gray-600" data-id="element-998" /> : <Eye className="h-4 w-4 text-gray-400 hover:text-gray-600" data-id="element-999" />}
                </button>
              </div>
            </div>

            {/* Remember Me and Forgot Password */}
            <div className="flex items-center justify-between" data-id="element-1000">
              <label className="flex items-center cursor-pointer" data-id="element-1001">
                <input type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500 cursor-pointer" data-id="element-1002" />
                <span className="ml-2 text-xs text-gray-700" data-id="element-1003">Ricordami</span>
              </label>
              <button type="button" className="text-xs text-green-600 hover:text-green-700 font-normal" data-id="element-1004">
                Password dimenticata?
              </button>
            </div>

            {/* Login Button */}
            <button type="submit" disabled={isLoading} className="w-full flex items-center justify-center py-3 px-4 rounded-full shadow-sm text-sm font-normal text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-1005">
              {isLoading ? <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1006" /> : 'Accedi'}
            </button>
          </form>

          {/* Divider */}
          <div className="mt-5" data-id="element-1007">
            <div className="relative" data-id="element-1008">
              <div className="absolute inset-0 flex items-center" data-id="element-1009">
                <div className="w-full border-t border-gray-200" data-id="element-1010" />
              </div>
              <div className="relative flex justify-center text-xs" data-id="element-1011">
                <span className="px-2 bg-white text-gray-500" data-id="element-1012">
                  Oppure accedi con
                </span>
              </div>
            </div>
          </div>

          {/* Social Login Buttons */}
          <div className="mt-5 space-y-2.5" data-id="element-1013">
            <button type="button" className="w-full flex items-center justify-center gap-2.5 py-2.5 px-4 border border-gray-200 rounded-xl shadow-sm text-xs font-normal text-gray-700 bg-white hover:bg-gray-50 focus:outline-none transition-all" data-id="element-1014">
              <svg className="h-4 w-4" viewBox="0 0 24 24" data-id="element-1015">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-1016" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-1017" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-1018" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-1019" />
              </svg>
              Google Workspace
            </button>

            <button type="button" className="w-full flex items-center justify-center gap-2.5 py-2.5 px-4 border border-gray-200 rounded-xl shadow-sm text-xs font-normal text-gray-700 bg-white hover:bg-gray-50 focus:outline-none transition-all" data-id="element-1020">
              <svg className="h-4 w-4" viewBox="0 0 23 23" data-id="element-1021">
                <path fill="#f3f3f3" d="M0 0h23v23H0z" data-id="element-1022" />
                <path fill="#f35325" d="M1 1h10v10H1z" data-id="element-1023" />
                <path fill="#81bc06" d="M12 1h10v10H12z" data-id="element-1024" />
                <path fill="#05a6f0" d="M1 12h10v10H1z" data-id="element-1025" />
                <path fill="#ffba08" d="M12 12h10v10H12z" data-id="element-1026" />
              </svg>
              Microsoft 365
            </button>
          </div>

          {/* Sign Up Link */}
          <div className="mt-5 text-center" data-id="element-1027">
            <p className="text-xs text-gray-600" data-id="element-1028">
              Non hai un account?{' '}
              <button type="button" onClick={() => onNavigate('signup')} className="text-green-600 hover:text-green-700 font-normal" data-id="element-1029">
                Registrati
              </button>
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-white/80 mt-4" data-id="element-1030">
          © 2025 Greenback. Tutti i diritti riservati.
        </p>
      </div>
    </div>;
}